import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { getConversionRateWithSpendersTooltipFormatter, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerNewUsersConversionRateByInfluencerChart = ({ data, influencerLabelMap, pending }) => {
  const { categories, series } = useMemo(() => {
    const labels = mapIdsToLabels(data?.influencerIds, influencerLabelMap);
    const spendersData = data?.spenders || [];
    const nonSpendersData = data?.nonSpenders || [];

    const rows = labels.map((label, index) => {
      const spenderCount = Number(spendersData[index] || 0);
      const nonSpenderCount = Number(nonSpendersData[index] || 0);
      const total = spenderCount + nonSpenderCount;
      const rate = total > 0 ? (spenderCount / total) * 100 : 0;
      return { label, rate, spenders: spenderCount, nonSpenders: nonSpenderCount };
    });

    rows.sort((a, b) => b.rate - a.rate);

    return {
      categories: rows.map(row => row.label),
      series: [
        {
          name: 'Conversion Rate',
          data: rows.map(row => row.rate),
          spenders: rows.map(row => row.spenders),
          nonSpenders: rows.map(row => row.nonSpenders),
        },
      ],
    };
  }, [data, influencerLabelMap]);
  const tooltipFormatter = useMemo(() => getConversionRateWithSpendersTooltipFormatter(), []);

  return (
    <OrganizationAnalyticsBarChart
      title="New Users Conversion Rate By Creator"
      subtitle="Share of new users that became spenders."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators to load conversion rate."
      valueType="percent"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationInfluencerNewUsersConversionRateByInfluencerChart;
